export default __webpack_public_path__ + "static/media/logo_atlas.203c97df.png";